module.exports = __webpack_public_path__ + "img/inpdf.8d87014e.png";